import { render, staticRenderFns } from "./SplitterPanel.vue?vue&type=template&id=ae1c53c2&"
import script from "./SplitterPanel.vue?vue&type=script&lang=js&"
export * from "./SplitterPanel.vue?vue&type=script&lang=js&"
import style0 from "./SplitterPanel.vue?vue&type=style&index=0&id=ae1c53c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports